'use client'

import { CollectionListingNoFilter } from '@/app/[locale]/collection/_components/collection-listing-no-filter'
import { ECollectionSort } from '@/app/[locale]/collection/constants'
import { Container } from '@/components/ui/container'
import { Tabs } from '@/components/ui/tabs'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'

type ProductsWithFilterTabProps = {
  flatten?: number
  forceFlatten?: number
}

export const ProductsWithFilterTab = ({
  flatten = 1,
  forceFlatten = 1,
}: ProductsWithFilterTabProps) => {
  const [activeTab, setActiveTab] = useState('shop-all')
  const t = useTranslations('collections_page')
  const searchParams = useSearchParams()

  //params gender_type
  const genderType = searchParams.get('gender_type')
  //params sort - default là price-asc (từ thấp đến cao)
  const sort = searchParams.get('sort') || ECollectionSort.PRICE_ASC

  return (
    <Container className='pt-2'>
      <div className='flex items-center justify-between'>
        <h2 className='font-criteria text-2xl font-bold uppercase leading-8 text-neutral-900 lg:text-4xl lg:leading-[44px]'>
          {t('heading')}
        </h2>
        {/* Sorting UI - có thể comment để ẩn giao diện mà không ảnh hưởng logic */}
        {/* <CollectionsSortSelect /> */}
      </div>

      <Tabs
        className='my-4 p-0 lg:mt-6'
        triggerClassName='text-sm leading-tight uppercase font-medium px-4 py-2 pt-2.5 lg:px-6 lg:py-3'
        variant='filter'
        options={[
          {
            value: 'shop-all',
            label: t('tabs.all'),
          },
          {
            value: 'ao-nam',
            label: t('tabs.top'),
          },
          {
            value: 'quan-nam',
            label: t('tabs.bottom'),
          },
          {
            value: 'quan-lot-nam',
            label: t('tabs.underwear'),
          },
          {
            value: 'phu-kien-nam',
            label: t('tabs.accessories'),
          },
        ]}
        defaultValue={activeTab}
        onChange={setActiveTab}
      />

      <CollectionListingNoFilter
        slug={activeTab}
        flatten={flatten}
        sort={sort}
        filter={[
          { key: 'visibility', value: 'true' },
          { key: 'force_flatten', value: forceFlatten },
          { key: 'gender_type', value: genderType || '' },
        ]}
      />
    </Container>
  )
}
